let timer = null;

function debounce(func, timeout = 300) {
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

module.exports = debounce;